import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { useSnackbar } from "notistack";
import {
  Typography,
  Grid,
  TextField,
  Autocomplete,
  Box,
  InputLabel,
  FormControl,
  Button,
  MenuItem,
  Select,
  IconButton,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/styles";
import { ArrowBackIosNew as ArrowBackIosNewIcon } from "@mui/icons-material";

import DialogShowDetailDialog from "../../components/edit/dialogShowDetailBooking";

import { getEmployeesByCompany } from "../../../../../../actions/employee";
import employeeService from "../../../../../../services/employee.service";
import userService from "../../../../../../services/user.service";
import SiteService from "../../../../../../services/site.service";
import BetweenSiteCarService from "../../../../../../services/betweenSiteCar.service";
import { getBetweenSiteByAdminFilter } from "../../../../../../actions/betweenSiteCarBooking";

export const useStylesDeliverySampleForm = makeStyles((theme) => ({
  PaddingBottom: {
    paddingBottom: "0 !important",
  },
  Title: {
    textAlign: "center",
    fontSize: "18px",
  },
  DivCoverReturn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  Grid: {
    marginTop: "10px",
  },
  Button: {
    width: "100px",
    height: "50px",
    fontSize: "18px",
    color: "white",
    backgroundColor: "green",
    ["&:hover"]: {
      backgroundColor: "darkgreen",
    },
  },
}));

export const DivContent = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: "1100px",
  padding: "10px",
  marginBottom: "50px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}));
export const DivCoverReturn = styled("div")(({ theme }) => ({
  width: "100%",
  marginTop: "20px",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "10px",
}));
export const TextMainTopic = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: "bold",
  marginBottom: "5px",
  color: theme.palette.text.primary,
}));
export const DivHead = styled("div")({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});
export const BackButton = styled(IconButton)(({ theme }) => ({
  color: "black",
  fontSize: "20px",
}));

const EditDetailBetweenSite = (props) => {
  const classes = useStylesDeliverySampleForm();
  const { enqueueSnackbar } = useSnackbar();
  const booking = props.location.state.booking;

  const formatDateToLocal = (dateString, offset) => {
    const date = new Date(dateString);
    date.setHours(date.getHours() + offset);
    return date.toISOString().slice(0, 16);
  };

  const convertToISO = (localDateStr) => {
    const local = new Date(localDateStr);
    return local.toISOString();
  };

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    getValues,
    setValue,
  } = useForm({});

  const [openDetailBooking, setOpenDetailBooking] = useState(false);
  const dispatch = useDispatch();
  const { result: allDriver } = useSelector((state) => state.drivers);
  const { result: allEmployees } = useSelector((state) => state.employees);
  const { user: currentUser } = useSelector((state) => state.auth);
  const [allSite, setAllSite] = useState([]);
  const [requester, setRequester] = useState(null);

  const onSubmitHandler = (date) => {
    setOpenDetailBooking(true);
  };

  const onCloseDialog = () => {
    setOpenDetailBooking(false);
  };

  const onClickSubmit = async () => {
    const myData = {
      idRequester: getValues("idRequester"),
      nameRequester: getValues("nameRequester"),
      phoneRequester: getValues("phoneRequester"),
      date: convertToISO(getValues("date")),
      pickupTime:
        getValues("pickupTime") && convertToISO(getValues("pickupTime")),
      dropoffTime:
        getValues("dropoffTime") && convertToISO(getValues("dropoffTime")),
      fromPlace: getValues("fromPlace"),
      toPlace: getValues("toPlace"),
      nameDriver: getValues("nameDriver"),
      idDriver: getValues("idDriver"),
      targetStatus:
        getValues("status") === "รอการจัดหาคนขับรถ"
          ? "Waiting"
          : getValues("status") === "กำลังไปรับ"
          ? "GettingPlace"
          : getValues("status") === "กำลังไปส่ง"
          ? "ToPlace"
          : "Finish",
    };

    BetweenSiteCarService.postEditBetweenSiteCar(
      myData,
      booking.idBetweenSiteCar
    ).then((res) => {
      if (res.data.type === "success") {
        enqueueSnackbar("Edit data Success", { variant: "success" });
        props.history.push("/admin/car_management/between_site_car");
        dispatch(
          getBetweenSiteByAdminFilter({ startDate: new Date(props.startDate) })
        );
      } else {
        enqueueSnackbar("Edit data Failed", { variant: "error" });
      }
    });
  };

  useEffect(() => {
    if (props.location.state === undefined) {
      props.history.push("/admin/car_management");
    }
  }, [props.location.state.booking]);

  useEffect(async () => {
    SiteService.getAllSiteLocations().then((res) => {
      if (res.data) {
        setAllSite(res.data);
      }
    });
    if (!allEmployees) {
      await employeeService.getEmployeesById(currentUser.idUser).then((res) => {
        if (res.data) {
          dispatch(getEmployeesByCompany(res.data[0].idCompany));
        }
      });
    }
    if (!allDriver) {
      await userService.getAllDriver(currentUser.idUser);
    }
    await userService.getUserProfile(booking.idUser).then((res) => {
      if (res.data) {
        setRequester(res.data);
        setValue("idRequester", res.data.idEmployees);
        setValue("nameRequester", booking.nameRequester);
      }
    });
    setValue("fromPlaceName", booking.fromPlace);
    setValue("toPlaceName", booking.toPlace);
    setValue("idDriver", booking.idDriver || null);
    if (booking.idDriver && allDriver) {
      setValue(
        "nameDriver",
        allDriver.find((driver) => driver.idUser === watch("idDriver")).FullName
      );
    }
  }, []);

  return (
    booking && (
      <DivCoverReturn>
        <DivContent>
          <DivHead>
            <BackButton onClick={() => props.history.goBack()}>
              <ArrowBackIosNewIcon />
            </BackButton>
            <Typography className={`${classes.Title}`}>
              แก้ไขรายการรถรับส่งระหว่าง Site
            </Typography>
            <div></div>
          </DivHead>
          <form onSubmit={handleSubmit(onSubmitHandler)}>
            <Grid container spacing={0}>
              <Grid
                container
                item
                spacing={3}
                xs={12}
                sx={(theme) => ({
                  display: "flex",
                  boxShadow:
                    "rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px",
                  border: "1px solid #EEEEEE",
                  backgroundColor: "#FBFCFC",
                  marginTop: "10px",
                  marginBottom: "20px",
                  marginLeft: "0px",
                  padding: "0 25px 25px 0",
                  width: "100%",

                  borderRadius: "15px",
                  [theme.breakpoints.down("sm")]: {},
                  [theme.breakpoints.down("md")]: {},
                })}
              >
                <Grid item xs={12}>
                  <TextMainTopic>รายละเอียดการจอง</TextMainTopic>
                </Grid>

                {allEmployees && requester !== null && (
                  <>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Controller
                        render={(propsInController) => (
                          <Autocomplete
                            options={allEmployees}
                            getOptionLabel={(option) =>
                              `${option.firstname_TH} ${option.lastname_TH}`
                            }
                            isOptionEqualToValue={(option, value) =>
                              option === value
                            }
                            renderOption={(props, option) => (
                              <Box component="li" {...props}>
                                {`${option.firstname_TH} ${option.lastname_TH}`}
                              </Box>
                            )}
                            value={propsInController.field.value}
                            onChange={(e, value) => {
                              if (value) {
                                setValue("idRequester", value.idEmployees);
                                setValue(
                                  "nameRequester",
                                  `${value.firstname_TH} ${value.lastname_TH}`
                                );
                                setValue(
                                  "phoneRequester",
                                  value.telephoneMobile
                                );
                                propsInController.field.onChange(value);
                              } else {
                                setValue("idRequester", null);
                                setValue("nameRequester", "");
                                setValue("phoneRequester", "");

                                propsInController.field.onChange(null);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name="nameRequester"
                                error={errors.Requester ? true : false}
                                helperText={
                                  errors.Requester
                                    ? "กรุณากรอกชื่อผู้จอง"
                                    : false
                                }
                                placeholder="ระบุชื่อ-นามสกุล"
                                label="ชื่อผู้จอง"
                                fullWidth
                                defaultValue={booking.nameRequester}
                                sx={{
                                  ".MuiInputBase-root": {
                                    borderRadius: "15px",
                                  },
                                }}
                              />
                            )}
                          />
                        )}
                        name="Requester"
                        control={control}
                        rules={{ required: true }}
                        defaultValue={requester}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={4}>
                      <Controller
                        render={(propsInController) => (
                          <TextField
                            name="phoneRequester"
                            error={errors.phoneRequester ? true : false}
                            InputLabelProps={{
                              shrink:
                                getValues("phoneRequester") === "" ||
                                getValues("phoneRequester") === null ||
                                getValues("phoneRequester") === undefined
                                  ? false
                                  : true,
                            }}
                            helperText={
                              errors.phoneSender
                                ? "กรุณากรอกเบอร์โทรผู้จอง"
                                : false
                            }
                            placeholder="ระบุเบอร์โทรผู้จอง"
                            label="เบอร์โทรผู้จอง"
                            fullWidth
                            inputProps={{
                              ...register("phoneRequester", { required: true }),
                            }}
                            value={propsInController.field.value}
                            InputProps={{
                              style: {
                                borderRadius: "15px",
                              },
                            }}
                          />
                        )}
                        name="phoneRequester"
                        control={control}
                        rules={{ required: true }}
                        defaultValue={booking.phoneRequester}
                      />
                    </Grid>
                  </>
                )}
                <Grid item xs={12} sm={6} lg={4}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>{"จุดรับต้นทาง"}</InputLabel>
                    <Controller
                      render={(propsInController) => (
                        <Select
                          name="fromPlace"
                          error={errors.fromPlace ? true : false}
                          helperText={
                            errors.fromPlace ? "กรุณาเลือกจุดรับต้นทาง" : false
                          }
                          label="จุดรับต้นทาง"
                          value={propsInController.field.value}
                          onChange={(e) => {
                            setValue(
                              "fromPlaceName",
                              allSite.map((value) => {
                                if (value.idScgSite === e.target.value) {
                                  if (value.noSite !== null) {
                                    return `Site${value.noSite}: ${value.nameSite}`;
                                  } else {
                                    return `${value.nameSite}`;
                                  }
                                }
                              })
                            );

                            propsInController.field.onChange(e);
                          }}
                          style={{ borderRadius: "15px" }}
                        >
                          {allSite.map((value, index) => (
                            <MenuItem key={index} value={value.idScgSite}>
                              {value.noSite !== null &&
                                `Site${value.noSite}:${value.nameSite}`}
                              {value.noSite === null && `${value.nameSite}`}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                      name="fromPlace"
                      control={control}
                      rules={{ required: true }}
                      defaultValue={booking.fromPlaceIdScgSite}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} lg={4}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>{"จุดส่งปลายทาง"}</InputLabel>
                    <Controller
                      render={(propsInController) => (
                        <Select
                          name="toPlace"
                          error={errors.toPlace ? true : false}
                          helperText={
                            errors.toPlace ? "กรุณาเลือกจุดส่งปลายทาง" : false
                          }
                          label="จุดส่งปลายทาง"
                          value={propsInController.field.value}
                          onChange={(e) => {
                            setValue(
                              "toPlaceName",
                              allSite.map((value) => {
                                if (value.idScgSite === e.target.value) {
                                  if (value.noSite !== null) {
                                    return `Site${value.noSite}: ${value.nameSite}`;
                                  } else {
                                    return `${value.nameSite}`;
                                  }
                                }
                              })
                            );

                            propsInController.field.onChange(e);
                          }}
                          style={{ borderRadius: "15px" }}
                        >
                          {allSite.map((value, index) => (
                            <MenuItem key={index} value={value.idScgSite}>
                              {value.noSite !== null &&
                                `Site${value.noSite}:${value.nameSite}`}
                              {value.noSite === null && `${value.nameSite}`}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                      name="toPlace"
                      control={control}
                      rules={{ required: true }}
                      defaultValue={booking.toPlaceIdScgSite}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} lg={4}>
                  <TextField
                    name="date"
                    fullWidth
                    label="วัน-เวลา ที่จอง"
                    type="datetime-local"
                    InputProps={{
                      style: {
                        borderRadius: "15px",
                      },
                    }}
                    defaultValue={formatDateToLocal(booking.date, 7)}
                    InputLabelProps={{ shrink: true }}
                    {...register("date", { required: true })}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                item
                spacing={3}
                xs={12}
                sx={(theme) => ({
                  display: "flex",
                  boxShadow:
                    "rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px",
                  border: "1px solid #EEEEEE",
                  backgroundColor: "#FBFCFC",
                  marginTop: "10px",
                  marginBottom: "20px",
                  marginLeft: "0px",
                  padding: "0 25px 25px 0",
                  width: "100%",
                  borderRadius: "15px",
                })}
              >
                <Grid item xs={12}>
                  <TextMainTopic>สถานะรายการ</TextMainTopic>
                </Grid>

                <Grid item xs={12} sm={6} lg={4}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>{"สถานะ"}</InputLabel>
                    <Controller
                      render={(propsInController) => (
                        <Select
                          label="สถานะ"
                          value={propsInController.field.value}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setValue("status", newValue);
                            propsInController.field.onChange(e);
                            if (booking.isFinish === 0) {
                              if (booking.targetStatus === "ToPlace") {
                                if (newValue === "รอการจัดหาคนขับรถ") {
                                  setValue("pickupTime", null);
                                } else if (newValue === "กำลังไปรับ") {
                                  setValue("pickupTime", null);
                                  setValue("idDriver", booking.idDriver);
                                } else {
                                  setValue(
                                    "pickupTime",
                                    formatDateToLocal(booking.pickupTime, 7)
                                  );
                                  setValue("idDriver", booking.idDriver);
                                }
                              } else {
                                setValue("idDriver", booking.idDriver);
                                setValue("pickupTime", null);
                                setValue("dropoffTime", null);
                              }
                            } else {
                              if (newValue === "รอการจัดหาคนขับรถ") {
                                setValue("pickupTime", null);
                                setValue("dropoffTime", null);
                              } else if (newValue === "กำลังไปรับ") {
                                setValue("idDriver", booking.idDriver);
                                setValue("pickupTime", null);
                                setValue("dropoffTime", null);
                              } else if (newValue === "กำลังไปส่ง") {
                                setValue("idDriver", booking.idDriver);
                                setValue(
                                  "pickupTime",
                                  formatDateToLocal(booking.pickupTime, 7)
                                );
                                setValue("dropoffTime", null);
                              } else {
                                setValue("idDriver", booking.idDriver);
                                setValue(
                                  "pickupTime",
                                  formatDateToLocal(booking.pickupTime, 7)
                                );
                                setValue(
                                  "dropoffTime",
                                  formatDateToLocal(booking.dropoffTime, 7)
                                );
                              }
                            }
                          }}
                          style={{ borderRadius: "15px" }}
                        >
                          <MenuItem value={"รอการจัดหาคนขับรถ"}>
                            รอการจัดหาคนขับรถ
                          </MenuItem>
                          <MenuItem value={"กำลังไปรับ"}>กำลังไปรับ</MenuItem>
                          <MenuItem value={"กำลังไปส่ง"}>กำลังไปส่ง</MenuItem>
                          <MenuItem value={"รายการเสร็จสิ้น"}>
                            รายการเสร็จสิ้น
                          </MenuItem>
                        </Select>
                      )}
                      name="status"
                      control={control}
                      defaultValue={
                        booking.isFinish === 0
                          ? booking.targetStatus === "Waiting"
                            ? "รอการจัดหาคนขับรถ"
                            : booking.targetStatus === "GettingPlace"
                            ? "กำลังไปรับ"
                            : "กำลังไปส่ง"
                          : "รายการเสร็จสิ้น"
                      }
                    />
                  </FormControl>
                </Grid>

                {["กำลังไปส่ง", "รายการเสร็จสิ้น"].includes(
                  watch("status")
                ) && (
                  <Grid item xs={12} sm={6} lg={4}>
                    <TextField
                      name="pickupTime"
                      fullWidth
                      label="วัน-เวลา ที่รับผู้โดยสารสำเร็จ"
                      type="datetime-local"
                      InputProps={{
                        style: {
                          borderRadius: "15px",
                        },
                      }}
                      defaultValue={
                        watch("pickupTime") ||
                        (booking.pickupTime
                          ? formatDateToLocal(booking.pickupTime, 7)
                          : new Date())
                      }
                      InputLabelProps={{ shrink: true }}
                      {...register("pickupTime", { required: true })}
                    />
                  </Grid>
                )}

                {["รายการเสร็จสิ้น"].includes(watch("status")) && (
                  <Grid item xs={12} sm={6} lg={4}>
                    <TextField
                      name="dropoffTime"
                      fullWidth
                      label="วัน-เวลา ที่ส่งผู้โดยสารสำเร็จ"
                      type="datetime-local"
                      InputProps={{
                        style: {
                          borderRadius: "15px",
                        },
                      }}
                      defaultValue={
                        watch("dropoffTime") ||
                        (booking.dropoffTime
                          ? formatDateToLocal(booking.dropoffTime, 7)
                          : new Date())
                      }
                      InputLabelProps={{ shrink: true }}
                      {...register("dropoffTime", { required: true })}
                    />
                  </Grid>
                )}

                {["กำลังไปรับ", "กำลังไปส่ง", "รายการเสร็จสิ้น"].includes(
                  watch("status")
                ) &&
                  allDriver && (
                    <Grid item xs={12} sm={6} lg={4}>
                      <Autocomplete
                        options={allDriver}
                        getOptionLabel={(option) => option.FullName}
                        value={
                          allDriver.find(
                            (driver) => driver.idUser === watch("idDriver")
                          ) || null
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="idDriver"
                            placeholder="ระบุชื่อ-นามสกุล"
                            label="ชื่อคนขับรถ"
                            fullWidth
                            sx={{
                              ".MuiInputBase-root": {
                                borderRadius: "15px",
                              },
                            }}
                            required={true}
                          />
                        )}
                        onChange={(e, value) => {
                          if (value) {
                            setValue("idDriver", value.idUser);
                            setValue("nameDriver", value.FullName);
                          }
                        }}
                      />
                    </Grid>
                  )}
              </Grid>
              <div className={`${classes.NavButton}`}>
                <Button className={`${classes.Button}`} type="submit">
                  ยืนยัน
                </Button>
              </div>
            </Grid>
          </form>

          {openDetailBooking && (
            <DialogShowDetailDialog
              open={openDetailBooking}
              handleClose={onCloseDialog}
              topic="รายละเอียดการแก้ไขการจองรถระหว่าง Site"
              dataList={[
                {
                  imgSrc: "/assets/Image/Icon/sender.png",
                  label: "ผู้จอง",
                  value: getValues("nameRequester"),
                },
                {
                  imgSrc: "/assets/Image/Icon/receiver.png",
                  label: "เบอร์ผู้จอง",
                  value: getValues("phoneRequester"),
                },
                {
                  imgSrc: "/assets/Image/Icon/receiver.png",
                  label: "วัน-เวลา ที่จอง",
                  value: new Date(getValues("date")).toLocaleString("th-TH", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                  }),
                },
                getValues("pickupTime") && {
                  icon: "/assets/Image/Icon/date.png",
                  label: "วัน-เวลา ที่รับผู้โดยสาร",
                  value: new Date(getValues("pickupTime")).toLocaleString(
                    "th-TH",
                    {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    }
                  ),
                },
                getValues("dropoffTime") && {
                  icon: "/assets/Image/Icon/date.png",
                  label: "วัน-เวลา ที่ส่งผู้โดยสาร",
                  value: new Date(getValues("dropoffTime")).toLocaleString(
                    "th-TH",
                    {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    }
                  ),
                },
                {
                  icon: "/assets/Image/Icon/date.png",
                  label: "ต้นทาง",
                  value: getValues("fromPlaceName"),
                },
                {
                  icon: "/assets/Image/Icon/date.png",
                  label: "ปลายทาง",
                  value: getValues("toPlaceName"),
                },
                getValues("nameDriver") &&
                  getValues("status") !== "รอการจัดหาคนขับรถ" && {
                    icon: "/assets/Image/Icon/date.png",
                    label: "คนขับ",
                    value: getValues("nameDriver"),
                  },
                {
                  icon: "/assets/Image/Icon/date.png",
                  label: "สถานะ",
                  value: getValues("status"),
                },
              ].filter(Boolean)}
              onClickSubmit={onClickSubmit}
            />
          )}
        </DivContent>
      </DivCoverReturn>
    )
  );
};

export default EditDetailBetweenSite;
